import type { SVGProps } from 'react';

const SvgVenus = (props: SVGProps<SVGSVGElement>) => (
  <svg version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 57.73 57.54" {...props}>
<g fill="#fff">
	<g>
		<path d="M54.73,47.61l1.87-1.87c0.19-0.19,0.19-0.51,0-0.71L43.94,32.38c-0.09-0.09-0.15-0.22-0.15-0.35V14.76
			c0-0.13-0.05-0.26-0.15-0.35l-2.64-2.64c-0.31-0.31-0.85-0.09-0.85,0.35v21.41c0,0.13,0.05,0.26,0.15,0.35l13.72,13.72
			C54.22,47.8,54.54,47.8,54.73,47.61z"/>
	</g>
	<g>
		<path d="M47.63,54.2l1.87-1.87c0.19-0.19,0.19-0.51,0-0.71L35.35,37.48c-0.09-0.09-0.15-0.22-0.15-0.35V6.17
			c0-0.13-0.05-0.26-0.15-0.35l-2.64-2.64c-0.31-0.31-0.85-0.09-0.85,0.35v35.1c0,0.13,0.05,0.26,0.15,0.35L46.92,54.2
			C47.12,54.39,47.43,54.39,47.63,54.2z"/>
	</g>
	<g>
		<path d="M13.79,32.38L1.13,45.04c-0.19,0.19-0.19,0.51,0,0.71L3,47.61c0.19,0.19,0.51,0.19,0.71,0l13.72-13.72
			c0.09-0.09,0.15-0.22,0.15-0.35V11.95c0-0.44-0.54-0.67-0.85-0.35l-2.64,2.64c-0.09,0.09-0.15,0.22-0.15,0.35v17.44
			C13.94,32.16,13.89,32.29,13.79,32.38z"/>
	</g>
	<g>
		<path d="M8.24,52.33l1.87,1.87c0.19,0.19,0.51,0.19,0.71,0l15.21-15.21c0.09-0.09,0.15-0.22,0.15-0.35V3.36
			c0-0.44-0.54-0.67-0.85-0.35l-2.64,2.64C22.58,5.74,22.53,5.87,22.53,6v31.13c0,0.13-0.05,0.26-0.15,0.35L8.24,51.63
			C8.04,51.82,8.04,52.14,8.24,52.33z"/>
	</g>
</g>
<path d="M-124.17-22.34"/>
</svg>
);

export default SvgVenus;
